module.exports = __webpack_public_path__ + "static/img/Michael_Walters_desktop.c87a3f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael_Walters_desktop.jpg
// module id = ifdJ
// module chunks = 0